import { render, staticRenderFns } from "./pointsList.vue?vue&type=template&id=51549526&scoped=true&"
import script from "./pointsList.vue?vue&type=script&lang=js&"
export * from "./pointsList.vue?vue&type=script&lang=js&"
import style0 from "./pointsList.vue?vue&type=style&index=0&id=51549526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51549526",
  null
  
)

export default component.exports